import React, { useState } from 'react';
import image1 from '../img/envision/aerospace/1635233089998.jpg';
import image2 from '../img/envision/aerospace/BUTUCHI BABU BURRA.jpeg';
import image3 from '../img/envision/aerospace/bhaskar_reddy_k.jpeg';
import image4 from '../img/envision/aerospace/Jyotheeswara Reddy.jpg';

import { FaLinkedin, FaTwitter, FaFacebook, FaInstagram } from 'react-icons/fa';
import Footer from './Footer';
import { Link } from 'react-router-dom';
const AboutLeadershipsecondcontainer = () => {
    const [isHovered1, setIsHovered1] = useState(false);
    const [isHovered2, setIsHovered2] = useState(false);
    const [isHovered3, setIsHovered3] = useState(false);
    const [isHovered4, setIsHovered4] = useState(false);

    return (
        <div>

            <div className="container" style={{ padding: '20px', marginTop: '10px' }}>
                <h1 style={{ textAlign: 'center', marginBottom: "35px" }}>
                    Advisory Board <span style={{ color: 'rgb(236 115 34)' }}>Members</span>
                </h1>
                <div className="row" style={{ justifyContent: "center" }}>
                    <div className="col-lg-3 mb-4">
                        <div
                            style={{
                                textAlign: 'center',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa',
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            className="leadership-card"
                        >
                            <Link to="/leadershipDatasecond" style={{ textDecoration: 'none', color: 'inherit' }}>
                                {/* <a href="leadershipDatasecond" style={{ textDecoration: 'none', color: 'inherit' }}> */}
                                <div
                                    className="bgimg-image-container-2"
                                    style={{
                                        height: '336px',
                                        backgroundColor: '#ccc',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={() => setIsHovered2(true)}
                                    onMouseLeave={() => setIsHovered2(false)}
                                >
                                    <img
                                        src={image2}
                                        alt="Butchi Babu Burra"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'block',
                                            // objectFit: 'cover',
                                            filter: isHovered2 ? 'none' : 'brightness(0.6)', // Apply filter based on hover
                                            transition: "transform 0.3s ease-in-out",
                                            transform: isHovered2 ? "scale(1.1)" : "scale(1)",
                                        }}
                                    />
                                    <div
                                        className="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgb(88 84 84 / 40%)', // Dark overlay color
                                            opacity: isHovered2 ? 0 : 1, // Remove overlay on hover
                                            transition: 'opacity 0.3s ease', // Smooth transition
                                        }}
                                    ></div>
                                </div>
                            </Link>
                            <div style={{ padding: '15px', background: 'rgb(236 115 34)',}}>
                                <h4 style={{ margin: '10px 0', color: '#fff', fontSize: '18px' }}>Butchi Babu Burra
                                    
                                </h4>
                                <br></br>
                                <p
                                    style={{
                                        margin: '5px 0',
                                        color: '#fff',
                                        fontSize: '14px',
                                        transition: 'color 0.3s ease',
                                    }}
                                    className="leadership-text-hover"
                                >
                                    Advisory Board Member of - BFSI
                                </p>
                                {/* Social Media Icons */}
                                <div style={{ marginTop: '10px' }}>
                                    <a href="https://www.linkedin.com/in/bbutchibabu/" target="_blank" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaLinkedin size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaTwitter size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaFacebook size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaInstagram size={20} />
                                    </a>
                                </div>
                            </div>
                            {/* </a> */}

                        </div>
                    </div>
                    {/* Card 1 */}
                    <div className="col-lg-3 mb-4">
                        <div
                            style={{
                                textAlign: 'center',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa',
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            className="leadership-card"
                        >
                            <Link to="/leadershipnagmohan" style={{ textDecoration: 'none', color: 'inherit' }}>
                                {/* <a href="leadershipnagmohan" style={{ textDecoration: 'none', color: 'inherit' }}> */}
                                <div
                                    className="bgimg-image-container-1"
                                    style={{
                                        height: '336px',
                                        backgroundColor: '#ccc',
                                        color: '#000',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={() => setIsHovered1(true)}
                                    onMouseLeave={() => setIsHovered1(false)}
                                >
                                    <img
                                        src={image1}
                                        alt="Naga Mohan Gollangi"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'block',
                                            // objectFit: 'cover',
                                            filter: isHovered1 ? 'none' : 'brightness(0.6)', // Apply filter based on hover
                                            transition: "transform 0.3s ease-in-out",
                                            transform: isHovered1 ? "scale(1.1)" : "scale(1)",
                                        }}
                                    />
                                    {/* Overlay that is visible initially */}
                                    <div
                                        className="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgb(88 84 84 / 40%)', // Dark overlay color
                                            opacity: isHovered1 ? 0 : 1, // Remove overlay on hover
                                            transition: 'opacity 0.3s ease', // Smooth transition
                                        }}
                                    ></div>
                                </div>
                            </Link>
                            <div style={{ padding: '15px', background: 'rgb(236 115 34)',  }}>
                                <h4 style={{ margin: '10px 0', color: '#fff', fontSize: '18px' }}>Naga Mohan Gollangi</h4>
                                <br></br>
                                <p
                                    style={{
                                        margin: '5px 0',
                                        color: '#fff',
                                        fontSize: '14px',
                                        transition: 'color 0.3s ease',
                                    }}
                                    className="leadership-text-hover"
                                >
                                    Advisory Board Member - BFSI
                                </p>
                                {/* Social Media Icons */}
                                <div style={{ marginTop: '10px' }}>
                                    <a href="https://www.linkedin.com/in/nagamohangollangi/" target="_blank" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaLinkedin size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaTwitter size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaFacebook size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaInstagram size={20} />
                                    </a>
                                </div>
                                
                            </div>
                            {/* </a> */}

                        </div>
                    </div>
                    <div className="col-lg-3 mb-4">
                        <div
                            style={{
                                textAlign: 'center',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa',
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            className="leadership-card"
                        >
                            <Link to="/leadershir" style={{ textDecoration: 'none', color: 'inherit' }}>
                                {/* <a href="leadershipnagmohan" style={{ textDecoration: 'none', color: 'inherit' }}> */}
                                <div
                                    className="bgimg-image-container-1"
                                    style={{
                                        height: '336px',
                                        backgroundColor: '#ccc',
                                        color: '#000',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={() => setIsHovered3(true)}
                                    onMouseLeave={() => setIsHovered3(false)}
                                >
                                    <img
                                        src={image3}
                                        alt="Naga Mohan Gollangi"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'block',
                                            // objectFit: 'cover',
                                            filter: isHovered3 ? 'none' : 'brightness(0.6)', // Apply filter based on hover
                                            transition: "transform 0.3s ease-in-out",
                                            transform: isHovered3 ? "scale(1.1)" : "scale(1)",
                                        }}
                                    />
                                    {/* Overlay that is visible initially */}
                                    <div
                                        className="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgb(88 84 84 / 40%)', // Dark overlay color
                                            opacity: isHovered3 ? 0 : 1, // Remove overlay on hover
                                            transition: 'opacity 0.3s ease', // Smooth transition
                                        }}
                                    ></div>
                                </div>
                            </Link>
                            <div style={{ padding: '15px', background: 'rgb(236 115 34)' }}>
                                <h4 style={{ margin: '10px 0', color: '#fff', fontSize: '18px' }}>Bhaskar Reddy.K </h4>
                                <br></br>
                                <p
                                    style={{
                                        margin: '5px 0',
                                        color: '#fff',
                                        fontSize: '14px',
                                        transition: 'color 0.3s ease',
                                    }}
                                    className="leadership-text-hover"
                                >
                                    Advisory Board Member - Strategy & Business Development
                                </p>
                                {/* Social Media Icons */}
                                <div style={{ marginTop: '10px' }}>
                                    <a href="https://www.linkedin.com/in/bhaskar-reddy-8b630a71/" target="_blank" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaLinkedin size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaTwitter size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaFacebook size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaInstagram size={20} />
                                    </a>
                                </div>
                            </div>
                            {/* </a> */}

                        </div>
                    </div>

                    <div className="col-lg-3 mb-4">
                        <div
                            style={{
                                textAlign: 'center',
                                boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
                                borderRadius: '8px',
                                overflow: 'hidden',
                                backgroundColor: '#f8f9fa',
                                transition: 'transform 0.3s ease-in-out',
                            }}
                            className="leadership-card"
                        >
                            <Link to="/ledersjyohesh" style={{ textDecoration: 'none', color: 'inherit' }}>
                                {/* <a href="leadershipnagmohan" style={{ textDecoration: 'none', color: 'inherit' }}> */}
                                <div
                                    className="bgimg-image-container-1"
                                    style={{
                                        height: '336px',
                                        backgroundColor: '#ccc',
                                        color: '#000',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: 'relative',
                                    }}
                                    onMouseEnter={() => setIsHovered4(true)}
                                    onMouseLeave={() => setIsHovered4(false)}
                                >
                                    <img
                                        src={image4}
                                        alt="Dr.Jyotheeswara Reddy Edula"
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            display: 'block',
                                            // objectFit: 'cover',
                                            filter: isHovered4 ? 'none' : 'brightness(0.6)', // Apply filter based on hover
                                            transition: "transform 0.3s ease-in-out",
                                            transform: isHovered4 ? "scale(1.1)" : "scale(1)",
                                        }}
                                    />
                                    {/* Overlay that is visible initially */}
                                    <div
                                        className="overlay"
                                        style={{
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            right: 0,
                                            bottom: 0,
                                            backgroundColor: 'rgb(88 84 84 / 40%)', // Dark overlay color
                                            opacity: isHovered4 ? 0 : 1, // Remove overlay on hover
                                            transition: 'opacity 0.3s ease', // Smooth transition
                                        }}
                                    ></div>
                                </div>
                            </Link>
                            <div style={{ padding: '15px', background: 'rgb(236 115 34)' }}>
                                <h4 style={{ margin: '10px 0', color: '#fff', fontSize: '18px' }}>Dr.Jyotheeswara Reddy Edula</h4>
                                <p
                                    style={{
                                        margin: '5px 0',
                                        color: '#fff',
                                        fontSize: '14px',
                                        transition: 'color 0.3s ease',
                                    }}
                                    className="leadership-text-hover"
                                >
                                    Advisory Board Member – Pharma & Healthcare
                                </p>
                                {/* Social Media Icons */}
                                <div style={{ marginTop: '10px' }}>
                                    <a href="https://www.linkedin.com/in/reddyedula/" target="_blank" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaLinkedin size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaTwitter size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaFacebook size={20} />
                                    </a>
                                    <a href="#" style={{ color: '#fff', margin: '0 5px' }}>
                                        <FaInstagram size={20} />
                                    </a>
                                </div>
                            </div>
                            {/* </a> */}

                        </div>
                    </div>

                    {/* Card 2 */}
                    <style>
                        {`
          body, h1, h2, h3, h4, h5, h6, p {
            font-family: "Helvetica Neue", sans-serif !important;
          }
        `}
                    </style>
                </div>
            </div>

        </div>
    );
};

export default AboutLeadershipsecondcontainer;
